import { reactive, ref, watch } from "vue";
import { ELocalStorageKey } from "/@/types";
import {
  getModelListApi,
  getWisdomMapListApi,
  getGisAreaApi,
  dictionariesApi,
} from "/@/api/manage";
import { getMapPointList, getMapPointListBySn } from "/@/api/annotation";
import store from "/@/store";
import { drawGisListPolygonAll } from "/@/hooks/draw-region";
import { MapPointsManager, MapPointData } from "/@/utils/mapPointsManager";
import eventIcon from "/@/assets/icons/event-icon.png";
import { CURRENT_CONFIG as config } from "/@/api/http/config";

// 声明全局 Cesium 类型
declare const Cesium: any;
export function loadModel() {
  const model = reactive({
    list: [] as any, // 模型列表
    viewer: null, // 地图图层
    modelFlag: true, // 是否跳转到模型
    stopWatch: [] as any, // 清除watch
    wisdomList: [] as any, // 智图3d模型
    pointsManager: null as MapPointsManager | null, // 点位管理器
    loadGeoJson,
  });
  const typeList = ref<any>([]); // 字典
  model.stopWatch.push(
    watch(
      () => store?.state?.onWaylineInfo.data,
      (dataAll) => {
        if (dataAll && dataAll.length > 0) {
          dataAll.forEach((data: any) => {
            if (data && data.wpmlPoints && data.wpmlPoints.length > 0) {
              model.modelFlag = false;
            }
          });
        }
      },
    ),
  );
  // 获取模型列表数据
  function getModelList() {
    const workspaceId: string =
      localStorage.getItem(ELocalStorageKey.WorkspaceId) || "";
    let params = {
      workspaceId,
      modelName: "",
      page_num: 1,
      page_size: -1,
    };
    getModelListApi(params).then((res) => {
      const list = res.data.records;
      //   console.log(20, list);
      let arr = [] as any;
      let whiteArr = [] as any;
      if (list && list.length > 0) {
        list.forEach((item: any) => {
          if (item.is_load) {
            // && item.url.includes("tileset.json")
            if (item.mode_type == 1 ) {
              if (item.file_name == "cd.zip") {
                whiteArr.push(item.url);
              } else {
                let url = item.url;
                arr.push({
                  url: url,
                  height: item.height || 0
                });
              }
            } else if (item.mode_type == 0) {
              roadImgUrl(item.url);
            }
          }
        });
      }
      roadModel(arr);
      roadWhiteModel(whiteArr);
    });
  }
  // 获取智图下的模型
  function getModelImg() {
    const workspaceId: string =
      localStorage.getItem(ELocalStorageKey.WorkspaceId) || "";
    let params = {
      workspaceId,
      current: 1,
      size: -1,
    };
    getWisdomMapListApi(params).then((res) => {
      const list = res.data.records;
      // console.log(58, res, list);
      let arr3d = [] as any;
      if (list && list.length > 0) {
        list.forEach((item: any) => {
          if (item.type == "3D" && item.is_load) {
            arr3d.push(item.preview_url);
          }
          if (item.type == "2D" && item.is_load) {
            roadImgUrl(item.url);
          }
        });
      }
      roadWisdomModel(arr3d);
    });
    getModelList();
  }
  // 更新模型高度
  function updateModelHeight(tileset: any, height: number) {
    if (!tileset || isNaN(height)) return;
    const boundingSphere = tileset.boundingSphere;
    const cartographic = Cesium.Cartographic.fromCartesian(boundingSphere.center);
    const surface = Cesium.Cartesian3.fromRadians(
      cartographic.longitude,
      cartographic.latitude,
      cartographic.height + Number(height)
    );
    const offset = Cesium.Cartesian3.fromRadians(
      cartographic.longitude,
      cartographic.latitude,
      cartographic.height
    );
    const translation = Cesium.Cartesian3.subtract(
      surface,
      offset,
      new Cesium.Cartesian3()
    );
    tileset.modelMatrix = Cesium.Matrix4.fromTranslation(translation);
  }

  // 测试加载模型
  function roadModel(data: any) {
    if (data && data.length > 0) {
      const viewer = model.viewer as any;
      if (viewer) {
        clearModel();
        data.forEach((item: any) => {
          let tileset; //设置一个变量来存放通过3DTiles创建的模型
          const url = typeof item === 'string' ? item : item.url;
          const height = typeof item === 'string' ? 0 : (item.height || 0);
          try {
            // 3d模型
            tileset = viewer.scene.primitives.add(
              new Cesium.Cesium3DTileset({
                url: url,
                maximumScreenSpaceError: 1, //最大的屏幕空间误差
                // maximumNumberOfLoadedTiles: 1000, //最大加载瓦片个数
                // preloadFlightDestinations: false, // 飞行目的地预加载
                // loadSiblings: false, // 加载兄弟瓦片
                // preloadWhenHidden: false,    // 后台不加载
              }),
            );
            viewer.scene.globe.depthTestAgainstTerrain = true;
            tileset.readyPromise.then(function (tileset: any) {
              // 应用高度调整
              updateModelHeight(tileset, height);
              
              model.list.push(tileset);

              if (model.modelFlag) {
                let boundingSphere = tileset.boundingSphere;
                let cartographic = Cesium.Cartographic.fromCartesian(
                  boundingSphere.center,
                );
                const newPosition = Cesium.Cartesian3.fromRadians(
                  cartographic.longitude - 0.00005,
                  cartographic.latitude - 0.0001,
                  cartographic.height + 1000,
                );
                viewer.camera.flyTo({
                  destination: newPosition,
                  orientation: {
                    heading: Cesium.Math.toRadians(0),
                    pitch: Cesium.Math.toRadians(-45),
                    roll: 0,
                  },
                });
                model.modelFlag = false;
              }
            });
          } catch (error: any) {
            console.log(`加载错误: ${error}`);
          }
        });
        if (model.stopWatch && model.stopWatch.length > 0) {
          model.stopWatch.forEach((item: any) => {
            item();
          });
          model.stopWatch = [];
        }
      }
    }
  }
  // 加载白膜模型 - 使用 Cesium Ion 资源
  function roadWhiteModel(data: any) {
    if (data && data.length > 0) {
      const viewer = model.viewer as any;
      if (viewer) {
        clearModel();
        // 使用 Cesium Ion 资源加载白膜建筑，参考 windweather 项目的实现
        Cesium.IonResource.fromAssetId(96188)
          .then((resource: any) => {
            let tileset;
            try {
              tileset = viewer.scene.primitives.add(
                new Cesium.Cesium3DTileset({
                  url: resource,
                  maximumScreenSpaceError: 16,
                  maximumMemoryUsage: 256, // 限制内存使用为 256MB
                }),
              );
              tileset.show = true;
              viewer.scene.globe.depthTestAgainstTerrain = false;

              tileset.readyPromise.then(function (tileset: any) {
                // 白膜建筑不需要额外的高度调整
                model.list.push(tileset);
              });
            } catch (error: any) {
              console.log(`白膜建筑加载错误: ${error}`);
            }
          })
          .catch((error: any) => {
            console.log(`Cesium Ion 资源加载错误: ${error}`);
            // 如果 Ion 资源加载失败，回退到原始 URL 加载方式
            data.forEach((item: any) => {
              let tileset;
              try {
                tileset = viewer.scene.primitives.add(
                  new Cesium.Cesium3DTileset({
                    url: item,
                    maximumScreenSpaceError: 4,
                    maximumNumberOfLoadedTiles: 1000,
                  }),
                );
                viewer.scene.globe.depthTestAgainstTerrain = false;
                tileset.readyPromise.then(function (tileset: any) {
                  tileset.heightReference =
                    Cesium.HeightReference.RELATIVE_TO_GROUND;
                  tileset.height = 100;
                  model.list.push(tileset);
                });
              } catch (error: any) {
                console.log(`回退加载错误: ${error}`);
              }
            });
          });

        if (model.stopWatch && model.stopWatch.length > 0) {
          model.stopWatch.forEach((item: any) => {
            item();
          });
          model.stopWatch = [];
        }
      }
    }
  }
  //   清除模型列表
  function clearModel() {
    if (model.list && model.list.length > 0 && model.viewer) {
      let viewer = model.viewer as any;
      model.list.forEach((item: any) => {
        viewer.scene.primitives.remove(item); // 清除特定的 tileset
      });
      model.list = [];
    }
  }
  //   清除3d智图模型列表
  function clearWisdomModel() {
    if (model.wisdomList && model.wisdomList.length > 0 && model.viewer) {
      let viewer = model.viewer as any;
      model.wisdomList.forEach((item: any) => {
        viewer.scene.primitives.remove(item); // 清除特定的 tileset
      });
      model.wisdomList = [];
    }
  }
  // 加载三维智图模型
  function roadWisdomModel(data: any) {
    if (data && data.length > 0) {
      const viewer = model.viewer as any;
      if (viewer) {
        clearWisdomModel();
        // 降低抗锯齿级别
        viewer.scene.postProcessStages.fxaa.enabled = true;

        // // 禁用阴影效果
        // viewer.scene.shadowMap.enabled = false;

        data.forEach((item: any) => {
          let tileset; //设置一个变量来存放通过3DTiles创建的模型
          try {
            // 3d模型
            tileset = viewer.scene.primitives.add(
              new Cesium.Cesium3DTileset({
                url: item,
                maximumScreenSpaceError: 1, //最大的屏幕空间误差
                // maximumNumberOfLoadedTiles: 2000, //最大加载瓦片个数
                // skipLevelOfDetail: true, // 禁用跳过细节层级
                // baseScreenSpaceError: 256, // 基础屏幕空间误差
                // skipScreenSpaceErrorFactor: 4, // 跳过屏幕空间误差因子
                // skipLevels: 1, // 跳过的层级
                // immediatelyLoadDesiredLevelOfDetail: true, // 立即加载所需的细节层级
                // loadSiblings: true, // 加载兄弟瓦片
                // preloadWhenHidden: true, // 隐藏时预加载
                preloadFlightDestinations: false, // 飞行目的地预加载
                // maximumMemoryUsage: 5120
                preloadWhenHidden: false, // 后台不加载
              }),
            );

            viewer.scene.globe.depthTestAgainstTerrain = false;
            tileset.readyPromise
              .then(function (tileset: any) {
                // tileset.debugShowContentBoundingVolume = true;
                // tileset.debugShowViewerRequestVolume = true;
                let boundingSphere = tileset.boundingSphere; // 模型的范围
                let cartographic = Cesium.Cartographic.fromCartesian(
                  boundingSphere.center,
                ); // 从笛卡尔位置创建一个新的位置实例（返回的是一个经纬度的
                let surface = Cesium.Cartesian3.fromRadians(
                  cartographic.longitude,
                  cartographic.latitude,
                  1.0,
                ); // 以经纬度的值来返回Cartesian3(xyz)的位置 ，/
                let offset = Cesium.Cartesian3.fromRadians(
                  cartographic.longitude,
                  cartographic.latitude,
                  5,
                ); // 以经纬度的值来返回Cartesian3(xyz)的位置 ，//>
                let translation = Cesium.Cartesian3.subtract(
                  offset,
                  surface,
                  new Cesium.Cartesian3(),
                ); // 计算两个笛卡尔的分量差异。
                tileset.modelMatrix =
                  Cesium.Matrix4.fromTranslation(translation);
                model.wisdomList.push(tileset);
                if (model.modelFlag) {
                  const newPosition = Cesium.Cartesian3.fromRadians(
                    cartographic.longitude,
                    cartographic.latitude,
                    cartographic.height + 2000,
                  );
                  // viewer.zoomTo(tileset);
                  viewer.camera.flyTo({ destination: newPosition });
                  model.modelFlag = false;
                }
              })
              .catch(function (error: any) {
                console.error("模型加载失败:", error);
              });
          } catch (error: any) {
            console.log(`加载错误: ${error}`);
          }
        });
      }
    }
  }
  // 加载二维瓦片
  function roadImgUrl(url: string) {
    const viewer = model.viewer as any;
    if (viewer) {
      // 二维瓦片
      const TDT_SL = new Cesium.UrlTemplateImageryProvider({
        url: `${url}{z}/{x}/{y}.png`,
        // url: 'http://112.19.171.189:1115/zlsgfmx/{z}/{x}/{y}.png',
        minimumLevel: 3,
        maximumLevel: 22,
        type: "xyz",
      });
      viewer.imageryLayers.addImageryProvider(TDT_SL);
    }
  }
  // 将颜色编码转成 rgba 输出
  function colorToRgba(color: any, alpha: any) {
    // 处理透明度参数，如果未提供则使用默认值1
    alpha = typeof alpha !== "undefined" ? Math.max(0, Math.min(1, alpha)) : 1;

    // 处理16进制颜色 (支持 #fff, #ffffff 格式)
    if (/^#([0-9A-Fa-f]{3}){1,2}$/.test(color)) {
      const hex = color.slice(1);
      // 处理3位的16进制颜色，转换为6位
      const fullHex =
        hex.length === 3
          ? hex
              .split("")
              .map((c: any) => c + c)
              .join("")
          : hex;

      // 解析RGB值
      const r = parseInt(fullHex.substring(0, 2), 16);
      const g = parseInt(fullHex.substring(2, 4), 16);
      const b = parseInt(fullHex.substring(4, 6), 16);

      return `rgba(${r}, ${g}, ${b}, ${alpha})`;
    }

    // 处理rgb格式
    const rgbMatch = color.match(
      /^rgb\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*\)$/,
    );
    if (rgbMatch) {
      const r = parseInt(rgbMatch[1], 10);
      const g = parseInt(rgbMatch[2], 10);
      const b = parseInt(rgbMatch[3], 10);

      // 确保数值在0-255范围内
      const clamp = (value: any) => Math.max(0, Math.min(255, value));
      return `rgba(${clamp(r)}, ${clamp(g)}, ${clamp(b)}, ${alpha})`;
    }

    // 处理rgba格式
    const rgbaMatch = color.match(
      /^rgba\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*,\s*([\d.]+)\s*\)$/,
    );
    if (rgbaMatch) {
      const r = parseInt(rgbaMatch[1], 10);
      const g = parseInt(rgbaMatch[2], 10);
      const b = parseInt(rgbaMatch[3], 10);
      // 如果没有指定alpha参数，则使用原透明度
      const finalAlpha =
        typeof alpha !== "undefined" ? alpha : parseFloat(rgbaMatch[4]);

      // 确保数值在有效范围内
      const clamp = (value: any) => Math.max(0, Math.min(255, value));
      return `rgba(${clamp(r)}, ${clamp(g)}, ${clamp(b)}, ${Math.max(
        0,
        Math.min(1, finalAlpha),
      )})`;
    }

    // 如果无法识别颜色格式，返回默认值
    console.warn("无法识别的颜色格式:", color);
    return `rgba(0, 0, 0, ${alpha})`;
  }
  // 获取字典 数据
  const getDictList = async () => {
    // gis 类型
    let params = {
      faId: 42,
      current: 1,
      size: -1,
    };
    const res = await dictionariesApi(params);
    if (res.code == 0) {
      const list = res.data.records;
      typeList.value = list;
    }
  };
  // 获取gis 列表数据并渲染
  const getGisList = async () => {
    await getDictList();
    const workspaceId: string =
      localStorage.getItem(ELocalStorageKey.WorkspaceId) || "";
    let params = {
      current: 1,
      size: -1,
      workspace: workspaceId,
    };
    const res = await getGisAreaApi(params);
    if (res.code == 0) {
      const list = res.data.records;
      // console.log(400,list);
      handleRegionList(list);
    }
  };
  const handleRegionList = async (list: any) => {
    const data = list;
    // console.log(542, list);

    if (!data || data.length === 0) {
      return;
    }

    // 优化1: 预处理 typeList 为 Map，实现 O(1) 查找
    const typeColorMap = new Map<string, string>(
      typeList.value.map((item: any) => [item.name, item.va]),
    );

    // 优化2: 颜色查找函数，避免重复遍历
    const getAreaColor = (statusStr: string): string => {
      if (!statusStr) return "rgb(10, 193, 108)";
      const statusArr = statusStr.split(",").filter((s) => s.trim()); // 过滤空字符串
      if (statusArr.length === 1) {
        const color = typeColorMap.get(statusArr[0]);
        return color || "rgb(10, 193, 108)";
      }
      // 多个类型的颜色
      return "rgb(10, 193, 108)";
    };

    // 优化3: 提前过滤有效的多边形区域
    const validRegions = data.filter(
      (item: any) =>
        item.area_type === 0 &&
        item.gis_map_ch_list &&
        item.gis_map_ch_list.length > 0,
    );

    if (validRegions.length === 0) {
      return;
    }

    // 优化4: 使用 map 代替 forEach，更函数式和高效
    const polygonData = validRegions
      .map((item: any) => {
        const color = getAreaColor(item.area_status || "");
        const pointColorRgba = colorToRgba(color, 1);
        const polygonColorRgba = colorToRgba(color, 0.2);

        // 优化5: 在一次遍历中完成所有计算
        let lngTotal = 0;
        let latTotal = 0;
        let northernmostPoint = item.gis_map_ch_list[0];
        let maxLat = Number(northernmostPoint.lat) || 0;

        const points: any[] = [];
        const pointList: any[] = [];

        item.gis_map_ch_list.forEach((pointItem: any) => {
          const lng = Number(pointItem.lng);
          const lat = Number(pointItem.lat);

          if (lng && lat && !isNaN(lng) && !isNaN(lat)) {
            lngTotal += lng;
            latTotal += lat;

            const cartesian = Cesium.Cartesian3.fromDegrees(lng, lat);
            points.push(cartesian);
            pointList.push({
              point: cartesian,
              sort: pointItem.rank,
              pointColor: pointColorRgba,
            });

            // 在同一次遍历中找到最北点
            if (lat > maxLat) {
              maxLat = lat;
              northernmostPoint = pointItem;
            }
          }
        });

        // 优化6: 提前计算避免重复访问
        const pointCount = points.length;
        if (pointCount === 0) {
          return null; // 跳过无效数据
        }

        // 优化7: 生成线段数组，保持与原始代码一致的结构
        const lines: any[] = [];
        if (pointCount > 1) {
          for (let i = 0; i < pointCount - 1; i++) {
            lines.push([points[i], points[i + 1]]);
          }
          // 添加闭合线段
          lines.push([points[pointCount - 1], points[0]]);
        }

        const centerLng = lngTotal / pointCount;
        const centerLat = latTotal / pointCount;
        const rulesLat = Number(northernmostPoint.lat) || 0;
        const rulesLng = Number(northernmostPoint.lng) || 0;
        const rullsId = item.rulls_id
          ? item.rulls_id.split(",").map(Number)
          : [];

        // 优化8: 直接构建最终数据结构，减少中间对象
        return {
          id: item.id,
          name: item.area_name || "",
          list: {
            point: points,
            pointList: pointList,
            line: lines,
            polygon: [
              {
                type: 1,
                list: points,
                id: item.id,
                polygonColor: polygonColorRgba,
              },
            ],
            nameList: [
              {
                name: item.area_name || "",
                point: Cesium.Cartesian3.fromDegrees(centerLng, centerLat),
                iconList: rullsId,
                times:
                  (item.repetition || "") +
                  (item.start_time || "") +
                  "至" +
                  (item.end_time || ""),
                lngPoint: Cesium.Cartesian3.fromDegrees(rulesLng, rulesLat),
                timeId: "time" + item.id,
                infoId: "info" + item.id,
                id: item.id,
              },
            ],
            rulesList: [],
            type: 1,
          },
        };
      })
      .filter(Boolean); // 过滤掉 null 值

    // 渲染所有多边形
    if (polygonData.length > 0) {
      // console.log(539,polygonData);

      drawGisListPolygonAll(model.viewer, polygonData, (val: any) => {
        // console.log(3199, val);
      });
    }
  };
  // 获取 GeoJSON 数据
  async function getGeoJsonData() {
    const workspaceId: string =
      localStorage.getItem(ELocalStorageKey.WorkspaceId) || "";
    let params = {
      current: 1,
      size: -1,
      workspace: workspaceId,
    };
    let list: any[] = ["/data/export_output_5.json"];
    // const res = await getGisAreaApi(params);
    // if (res.code == 0) {
    //   list = res.data.records;
    //   handleRegionList(list);
    // }
    if (list && list.length > 0) {
      loadGeoJson(list, { zoomTo: true });
    }
  }
  // 加载 GeoJSON 数据
  async function loadGeoJson(url: string | string[], options: any = {}) {
    const viewer = model.viewer as any;
    if (!viewer || !url) return;

    const urls = Array.isArray(url) ? url : [url];
    const strokeColor = options.stroke || Cesium.Color.LIGHTBLUE;
    const instances: any[] = [];
    let minLon = 180,
      maxLon = -180,
      minLat = 90,
      maxLat = -90;
    let hasValidData = false;

    const processCoords = (coords: any[]) => {
      if (!coords || coords.length < 2) return null;
      const flatCoords = coords
        .flat()
        .filter((val: any) => typeof val === "number" && !isNaN(val));
      if (flatCoords.length < 4) return null;

      for (let i = 0; i < flatCoords.length; i += 2) {
        const lon = flatCoords[i];
        const lat = flatCoords[i + 1];
        if (lon < minLon) minLon = lon;
        if (lon > maxLon) maxLon = lon;
        if (lat < minLat) minLat = lat;
        if (lat > maxLat) maxLat = lat;
      }
      return Cesium.Cartesian3.fromDegreesArray(flatCoords);
    };

    const addInstance = (positions: any) => {
      if (!positions) return;
      instances.push(
        new Cesium.GeometryInstance({
          geometry: new Cesium.GroundPolylineGeometry({
            positions: positions,
            width: options.strokeWidth || 2.0,
          }),
          attributes: {
            color: Cesium.ColorGeometryInstanceAttribute.fromColor(strokeColor),
          },
        }),
      );
      hasValidData = true;
    };

    try {
      console.log(
        "开始并行加载并使用 GroundPolylinePrimitive 优化解析多个 GeoJSON:",
        urls,
      );

      // 并行 fetch 所有数据
      const dataResults = await Promise.all(
        urls.map(async (u) => {
          try {
            const response = await fetch(u);
            return await response.json();
          } catch (e) {
            console.error(`加载 GeoJSON 失败 (${u}):`, e);
            return null;
          }
        }),
      );

      dataResults.forEach((data) => {
        if (!data || !data.features) return;

        data.features.forEach((feature: any) => {
          if (!feature.geometry) return;

          if (feature.geometry.type === "Polygon") {
            addInstance(processCoords(feature.geometry.coordinates[0]));
          } else if (feature.geometry.type === "MultiPolygon") {
            feature.geometry.coordinates.forEach((poly: any) => {
              addInstance(processCoords(poly[0]));
            });
          }
        });
      });

      if (instances.length > 0) {
        const primitive = new Cesium.GroundPolylinePrimitive({
          geometryInstances: instances,
          appearance: new Cesium.PolylineColorAppearance(),
        });
        viewer.scene.groundPrimitives.add(primitive);
      }

      // 跳转视角
      if (options.zoomTo !== false && hasValidData) {
        viewer.camera.flyTo({
          destination: Cesium.Rectangle.fromDegrees(
            minLon,
            minLat,
            maxLon,
            maxLat,
          ),
          duration: 2.0,
        });
      }
    } catch (error) {
      console.error("解析 GeoJSON 集合失败:", error);
    }
  }
  // 加载所有点位数据到地图（优化版：分批渲染，避免阻塞主线程）
  // airportSn: 机场sn，如果传入则只加载该机场的点位，不传则加载所有点位
  async function loadAllPointsForMap(
    onClick?: (point: MapPointData) => void,
    airportSn?: string,
  ) {
    const viewer = model.viewer as any;
    if (!viewer) return;

    const workspaceId: string =
      localStorage.getItem(ELocalStorageKey.WorkspaceId) || "";

    try {
      let points: MapPointData[] = [];

      // 根据是否传入 airportSn 调用不同的接口
      if (airportSn) {
        // 有 airportSn 时调用 MapPoint/list 接口
        const res = await getMapPointListBySn(workspaceId, airportSn);
        if (res.code === 0 && res.data) {
          points = res.data.map((item: any) => ({
            id: item.id,
            name: item.name || "",
            lng: item.lng,
            lat: item.lat,
            h: item.h || 0,
            type: item.type || "",
            ...item,
          }));
        }
      } else {
        // 没有 airportSn 时调用原来的 MapPoint/page 接口
        const res = await getMapPointList(workspaceId, "", 1, -1, "", "", "");
        if (res.code === 0 && res.data?.records) {
          points = res.data.records.map((item: any) => ({
            id: item.id,
            name: item.name || "",
            lng: item.lng,
            lat: item.lat,
            h: item.h || 0,
            type: item.type || "",
            ...item,
          }));
        }
      }

      // 初始化点位管理器
      if (!model.pointsManager) {
        model.pointsManager = new MapPointsManager(viewer, {
          iconUrl: eventIcon,
          iconScale: 1,
          labelShowHeight: 5000,
          onClick: onClick,
        });
      }

      // 分批渲染点位，避免阻塞主线程
      // 对于大量点位（>1000），使用更小的批次和更长的延迟
      const batchSize = points.length > 1000 ? 3 : 5; // 超过 1000 个点位时，每批只渲染 3 个
      const totalBatches = Math.ceil(points.length / batchSize);

      // 使用 requestIdleCallback 在浏览器空闲时渲染
      let currentBatch = 0;

      const renderBatch = () => {
        if (currentBatch >= totalBatches) {
          return;
        }

        const start = currentBatch * batchSize;
        const end = Math.min(start + batchSize, points.length);
        const batchPoints = points.slice(start, end);

        // 渲染当前批次
        if (currentBatch === 0) {
          // 第一批直接更新
          model.pointsManager!.updatePoints(batchPoints);
        } else {
          // 后续批次追加
          model.pointsManager!.addPoints(batchPoints);
        }

        currentBatch++;

        // 动态调整延迟：
        // - 前 10 批使用更长延迟（100ms），给 Cesium 充足时间完成地形采样
        // - 后续批次使用较短延迟（50ms），加快加载速度
        const delay = currentBatch <= 10 ? 100 : 50;

        // 使用 requestIdleCallback 或 setTimeout 继续下一批
        if (typeof requestIdleCallback !== "undefined") {
          requestIdleCallback(() => renderBatch(), { timeout: 200 });
        } else {
          setTimeout(renderBatch, delay);
        }
      };

      // 延迟 100ms 开始渲染，给地图初始化留出时间
      setTimeout(() => {
        renderBatch();
      }, 100);
    } catch (error) {
      console.error("加载点位数据失败:", error);
    }
  }
  // 清除点位
  function clearMapPoints() {
    if (model.pointsManager) {
      model.pointsManager.destroy();
      model.pointsManager = null;
    }
  }

  // 显示点位
  function showMapPoints() {
    if (model.pointsManager) {
      model.pointsManager.show();
    }
  }

  // 分批显示点位（渐进式显示，避免卡顿）
  function showMapPointsBatch(batchSize: number = 10) {
    if (model.pointsManager) {
      model.pointsManager.showBatch(batchSize);
    }
  }

  // 隐藏点位
  function hideMapPoints() {
    if (model.pointsManager) {
      model.pointsManager.hide();
    }
  }

  // 设置点位可见性
  function setMapPointsVisible(visible: boolean) {
    if (model.pointsManager) {
      model.pointsManager.setVisible(visible);
    }
  }

  // 等待地形加载完成
  function waitForTerrainLoad(viewer: any): Promise<void> {
    return new Promise((resolve) => {
      // 如果地形已经加载完成（队列为空），直接返回
      if (viewer.scene.globe.tilesLoaded) {
        resolve();
        return;
      }

      // 监听地形瓦片加载进度
      const removeListener =
        viewer.scene.globe.tileLoadProgressEvent.addEventListener(
          (queuedTileCount: number) => {
            // 当队列中没有待加载的瓦片时，表示地形加载完成
            if (queuedTileCount === 0) {
              removeListener(); // 移除监听器
              resolve();
            }
          },
        );

      // 设置超时保护，避免无限等待（最多等待 5 秒）
      setTimeout(() => {
        removeListener();
        resolve();
      }, 5000);
    });
  }

  //   入口
  function gloabinitModel(
    viewer: any,
    modelFlag = true,
    autoLoadPoints = true,
  ) {
    model.viewer = viewer;
    model.modelFlag = modelFlag;
    getModelImg();

    // 优化加载顺序：先加载 GIS 区域（较少），再加载点位（较多）
    // 延迟加载 GIS 区域，等待地图初始化稳定后再添加
    setTimeout(() => {
      if (config.layout.aigisFlag) {
        getGisList();
      }
    }, 800);

    // 只有在 autoLoadPoints 为 true 时才自动加载点位
    if (autoLoadPoints) {
      // 等待地形加载完成后再加载点位
      setTimeout(async () => {
        await waitForTerrainLoad(viewer);
        loadAllPointsForMap();
      }, 1000); // 先等待 1 秒让地图基本初始化，然后等待地形加载完成
    }
    // 加载指定的 GeoJSON 数据并跳转到该位置
    // getGeoJsonData()
  }
  // 检查是否已加载点位数据
  function hasPointsLoaded(): boolean {
    return model.pointsManager !== null;
  }

  return {
    gloabinitModel,
    clearModel,
    clearWisdomModel,
    loadAllPointsForMap,
    clearMapPoints,
    showMapPoints,
    showMapPointsBatch,
    hideMapPoints,
    setMapPointsVisible,
    hasPointsLoaded, // 导出检查方法
  };
}
